var scope_0 = require('/vercel/path0/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/34525d583e7900ca2cdab928f00eb6e0.js').default;export default
        Object.assign({}, scope_0 )
    